import { getData, isAuth } from "actions";
import axios from "axios";
import {
  BreadcrumbPortal,
  CompPagination,
  FooterPortal,
  NavbarPortal,
  SearchPortal,
} from "components";
import PaginationAgent from "components/pagination/PaginationAgent";
import { API_URL_ticket, API_URL_updateBatchTicket } from "constants/api";
import { AuthContext } from "context/AuthContext";
import useDebounce from "hooks/useDebounce";
import moment from "moment";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { BiSortDown, BiSortUp } from "react-icons/bi";
import { FaComment, FaLock, FaLockOpen, FaSync } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { PulseLoader, SyncLoader } from "react-spinners";

import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import { ticketReducers } from "redux/ticketSlice";
import { slicingWord } from "utils/slicingWord";

// field for use sort up/down
const TABLE_HEAD = [
  { title: "Subjek", field: "" },
  { title: "ID Ticket", field: "ticket_number" },
  { title: "Prioritas", field: "priority" },
  { title: "Yang Ditugaskan", field: "" },
  { title: "Aktivitas Terakhir", field: "updated_at" },
  { title: "Status", field: "status_name" },
];

const MyTicket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const datauserToken = isAuth();
  const { datauser } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  const [sortColumnOpen, setSortColumnOpen] = useState("");
  const [limitOpen, setLimitOpen] = useState(10);
  const [offsetOpen, setOffsetOpen] = useState(0);
  const [sortOrderOpen, setSortOrderOpen] = useState("asc");
  const [currentPageOpen, setCurrentPageOpen] = useState(0);
  const [searchOpen, setSearchOpen] = useState("");
  const [checkAllOpen, setCheckAllOpen] = useState(false);
  const [checkedItemsOpen, setCheckedItemsOpen] = useState([]);
  const [loadingOpen, setLoadingOpen] = useState(true);
  const [errorOpen, setErrorOpen] = useState(false);
  const [refreshOpen, setRefreshOpen] = useState(false);

  const [sortColumnClose, setSortColumnClose] = useState("");
  const [limitClose, setLimitClose] = useState(10);
  const [offsetClose, setOffsetClose] = useState(0);
  const [sortOrderClose, setSortOrderClose] = useState("asc");
  const [currentPageClose, setCurrentPageClose] = useState(0);
  const [searchClose, setSearchClose] = useState("");
  const [checkAllClose, setCheckAllClose] = useState(false);
  const [checkedItemsClose, setCheckedItemsClose] = useState([]);
  const [loadingClose, setLoadingClose] = useState(true);
  const [errorClose, setErrorClose] = useState(false);
  const [refreshClose, setRefreshClose] = useState(false);

  const [dataTicketOpen, setDataTicketOpen] = useState([]);
  const [dataTicketClose, setDataTicketClose] = useState([]);

  const getTicketOpen = (params) => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      url: API_URL_ticket + params,
    })
      .then((response) => {
        setDataTicketOpen(response.data);
      })
      .catch((error) => {
        console.log(error);
        setErrorOpen(error);
      });
  };

  const getTicketClose = (params) => {
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      url: API_URL_ticket + params,
    })
      .then((response) => {
        setDataTicketClose(response.data);
      })
      .catch((error) => {
        console.log(error);
        setErrorClose(error);
      });
  };

  const handlePageClickOpen = ({ selected }) => {
    const newOffset = selected * limitOpen;
    const params = `?clientportal=${
      datauserToken.user_id
    }&status=1&limit=${limitOpen}&offset=${newOffset}&search=${searchOpen}&ordering=${
      sortOrderOpen === "desc" ? "-" : ""
    }${sortColumnOpen}`;
    setOffsetOpen(newOffset);
    setCurrentPageOpen(selected);
    getTicketOpen(params);
  };

  const handlePageClickClose = ({ selected }) => {
    const newOffset = selected * limitClose;
    const params = `?clientportal=${
      datauserToken.user_id
    }&status=3&limit=${limitClose}&offset=${newOffset}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    setOffsetClose(newOffset);
    setCurrentPageClose(selected);
    getTicketClose(params);
  };

  const delayedSearchOpen = useCallback(
    useDebounce((value) => {
      //RESET PAGINATE KE 1
      setOffsetOpen(0);
      setCurrentPageOpen(0);
      const params = `?clientportal=${
        datauserToken.user_id
      }&status=1&limit=${limitOpen}&offset=${offsetOpen}&search=${value}&ordering=${
        sortOrderOpen === "desc" ? "-" : ""
      }${sortColumnOpen}`;
      getTicketOpen(params);
    }, 1000),
    [limitOpen, offsetOpen, sortOrderOpen, sortColumnOpen]
  );
  const delayedSearchClose = useCallback(
    useDebounce((value) => {
      //RESET PAGINATE KE 1
      setOffsetClose(0);
      setCurrentPageClose(0);
      const params = `?clientportal=${
        datauserToken.user_id
      }&status=3&limit=${limitClose}&offset=${offsetClose}&search=${value}&ordering=${
        sortOrderClose === "desc" ? "-" : ""
      }${sortColumnClose}`;
      getTicketClose(params);
    }, 1000),
    [limitClose, offsetClose, sortOrderClose, sortColumnClose]
  );

  const onSearchOpen = (value) => {
    setSearchOpen(value);
    delayedSearchOpen(value);
  };
  const onSearchClose = (value) => {
    setSearchClose(value);
    delayedSearchClose(value);
  };

  const handleSortOpen = (column) => {
    //RESET PAGINATE KE 1
    setOffsetOpen(0);
    setCurrentPageOpen(0);
    if (column === sortColumnOpen) {
      setSortOrderOpen(sortOrderOpen === "asc" ? "desc" : "asc");
    } else {
      setSortColumnOpen(column);
      setSortOrderOpen("asc");
    }
  };
  const handleSortClose = (column) => {
    //RESET PAGINATE KE 1
    setOffsetClose(0);
    setCurrentPageClose(0);
    if (column === sortColumnClose) {
      setSortOrderClose(sortOrderClose === "asc" ? "desc" : "asc");
    } else {
      setSortColumnClose(column);
      setSortOrderClose("asc");
    }
  };

  const renderSortIconOpen = (field) => {
    if (field === sortColumnOpen) {
      return sortOrderOpen === "asc" ? (
        <BiSortUp className="ml-1 h-4" />
      ) : (
        <BiSortDown className="ml-1 h-4" />
      );
    }
    return <BiSortUp className="ml-1 h-4 text-gray-300" />;
  };
  const renderSortIconClose = (field) => {
    if (field === sortColumnClose) {
      return sortOrderClose === "asc" ? (
        <BiSortUp className="ml-1 h-4" />
      ) : (
        <BiSortDown className="ml-1 h-4" />
      );
    }
    return <BiSortUp className="ml-1 h-4 text-gray-300" />;
  };

  const handleSelectLimitOpen = (limitOpen) => {
    //RESET PAGINATE KE 1
    setOffsetOpen(0);
    setCurrentPageOpen(0);

    const params = `?clientportal=${
      datauserToken.user_id
    }&status=1&limit=${limitOpen}&offset=${offsetOpen}&search=${searchOpen}&ordering=${
      sortOrderOpen === "desc" ? "-" : ""
    }${sortColumnOpen}`;
    getTicketOpen(params);
    setLimitOpen(limitOpen);
  };
  const handleSelectLimitClose = (limitClose) => {
    //RESET PAGINATE KE 1
    setOffsetClose(0);
    setCurrentPageClose(0);

    const params = `?clientportal=${
      datauserToken.user_id
    }&status=3&limit=${limitClose}&offset=${offsetClose}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    getTicketClose(params);
    setLimitClose(limitClose);
  };

  const fetchDataOpen = useCallback(() => {
    const params = `?clientportal=${
      datauserToken.user_id
    }&status=1&limit=${limitOpen}&offset=${offsetOpen}&search=${searchOpen}&ordering=${
      sortOrderOpen === "desc" ? "-" : ""
    }${sortColumnOpen}`;
    getTicketOpen(params);
  }, [
    getTicketOpen,
    limitOpen,
    offsetOpen,
    sortColumnOpen,
    sortOrderOpen,
    refreshOpen,
  ]);
  const fetchDataClose = useCallback(() => {
    const params = `?clientportal=${
      datauserToken.user_id
    }&status=3&limit=${limitClose}&offset=${offsetClose}&search=${searchClose}&ordering=${
      sortOrderClose === "desc" ? "-" : ""
    }${sortColumnClose}`;
    getTicketClose(params);
  }, [
    getTicketClose,
    limitClose,
    offsetClose,
    sortColumnClose,
    sortOrderClose,
    refreshClose,
  ]);

  // Function to handle refresh
  const handleRefreshOpen = () => {
    setRefreshOpen(!refreshOpen);
    setDataTicketOpen([]);
  };
  const handleRefreshClose = () => {
    setRefreshClose(!refreshClose);
    setDataTicketClose([]);
  };

  // Function for checking all checkboxes
  const handleCheckAllChangeOpen = (e) => {
    setCheckAllOpen(e.target.checked);

    if (e.target.checked) {
      // If checkAll is enabled, sets all records as checked
      let index = [];
      for (let i = 0; i < dataTicketOpen.results?.length; i++) {
        index.push(dataTicketOpen.results[i]?.id);
      }
      const allItems = index;
      setCheckedItemsOpen(allItems);
    } else {
      // If checkAll is disabled, clear the checkedItems list
      setCheckedItemsOpen([]);
    }
  };
  const handleCheckAllChangeClose = (e) => {
    setCheckAllClose(e.target.checked);

    if (e.target.checked) {
      // If checkAll is enabled, sets all records as checked
      let index = [];
      for (let i = 0; i < dataTicketClose.results?.length; i++) {
        index.push(dataTicketClose.results[i]?.id);
      }
      const allItems = index;
      setCheckedItemsClose(allItems);
    } else {
      // If checkAll is disabled, clear the checkedItems list
      setCheckedItemsClose([]);
    }
  };

  // Function for checking one item
  const handleCheckboxChangeOpen = (e, item) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // If the record is checked, add it to the checkedItems list
      setCheckedItemsOpen([...checkedItemsOpen, item]);
    } else {
      // If the record is not checked, remove it from the checkedItems list
      const updatedItems = checkedItemsOpen.filter(
        (checkedItem) => checkedItem !== item
      );
      setCheckedItemsOpen(updatedItems);
    }
  };
  const handleCheckboxChangeClose = (e, item) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // If the record is checked, add it to the checkedItems list
      setCheckedItemsClose([...checkedItemsClose, item]);
    } else {
      // If the record is not checked, remove it from the checkedItems list
      const updatedItems = checkedItemsClose.filter(
        (checkedItem) => checkedItem !== item
      );
      setCheckedItemsClose(updatedItems);
    }
  };

  const alertPermissionRestricted = () => {
    toast.warning("Maaf, anda tidak memiliki akses untuk melakukan ini.", {
      position: "top-center",
      autoClose: true,
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  //funtion to handle
  const HandleToClose = () => {
    setLoading(true);

    // Have permission can close ticket portal?
    const permission = datauser.group_permissions;
    const canCloseTicketPortal = permission.includes("can_close_ticket_portal");
    if (!canCloseTicketPortal) {
      alertPermissionRestricted();
      setLoading(false);
      return;
    }

    if (checkedItemsOpen.length === 0) {
      setLoading(false);
      toast.warning("Silakan checklist tiket minimal 1", {
        position: "top-center",
        autoClose: true,
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    let dataUpdate = [];
    checkedItemsOpen.map((item, index) => {
      const data = {
        id: item,
        status: 3,
        closed: 1,
        reopened: 0,
        by_user: datauser.id,
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoading(false);
        toast.success("Ticket berhasil di tutup", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        setCheckAllOpen(false);
        setCheckedItemsOpen([]);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        setCheckAllOpen(false);
        setCheckedItemsOpen([]);
      });
  };
  const HandleToOpen = () => {
    setLoading(true);

    // Have permission can open ticket portal?
    const permission = datauser.group_permissions;
    const canOpenTicketPortal = permission.includes("can_open_ticket_portal");
    if (!canOpenTicketPortal) {
      alertPermissionRestricted();
      setLoading(false);
      return;
    }

    if (checkedItemsClose.length === 0) {
      setLoading(false);
      toast.warning("Silakan checklist tiket minimal 1", {
        position: "top-center",
        autoClose: true,
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    let dataUpdate = [];
    checkedItemsClose.map((item, index) => {
      const data = {
        id: item,
        status: 1,
        closed: 0,
        reopened: 1,
        by_user: datauser.id,
      };
      dataUpdate.push(data);
    });
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "POST",
      data: { updates: dataUpdate },
      url: API_URL_updateBatchTicket,
    })
      .then((response) => {
        setLoading(false);
        toast.success("Ticket berhasil di buka", {
          position: "top-center",
          autoClose: true,
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        fetchDataOpen();
        fetchDataClose();
        setCheckAllClose(false);
        setCheckedItemsClose([]);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        fetchDataOpen();
        fetchDataClose();
        setCheckAllClose(false);
        setCheckedItemsClose([]);
      });
  };

  useEffect(() => {
    if (isAuth === undefined) {
      navigate("/");
    }
    fetchDataOpen();
    fetchDataClose();
  }, []);

  useEffect(() => {
    fetchDataOpen();
  }, [
    limitOpen,
    offsetOpen,
    sortColumnOpen,
    sortOrderOpen,
    datauserToken.user_id,
  ]);
  useEffect(() => {
    fetchDataClose();
  }, [
    limitClose,
    offsetClose,
    sortColumnClose,
    sortOrderClose,
    datauserToken.user_id,
  ]);

  useEffect(() => {
    fetchDataOpen();
  }, [refreshOpen]);

  useEffect(() => {
    fetchDataClose();
  }, [refreshClose]);

  useEffect(() => {
    setLoadingOpen(false);
    setLoadingClose(false);
  }, [dataTicketOpen, dataTicketClose]);

  return (
    <>
      <div className="flex flex-col min-h-screen overflow-y-auto text-gray-700">
        <NavbarPortal current={"Tiket Saya"} />
        <SearchPortal />

        <main className="flex flex-grow">
          <div className="mx-auto w-full max-w-[90rem] md:px-8 bg-transparent">
            <div className="relative mx-1 md:mx-0 bottom-6 bg-neutral-50 shadow-sm shadow-sky-800 rounded">
              <div className="mx-4 md:mx-10 py-2 md:py-4">
                <Tabs>
                  <TabList>
                    <Tab>
                      <div className="text-green-500 font-semibold">
                        Opened
                        <span className="text-xs ml-2 bg-black rounded px-1 text-white">
                          {dataTicketOpen && dataTicketOpen.count}
                        </span>
                      </div>
                    </Tab>
                    <Tab>
                      <div className="text-red-500 font-semibold">
                        Closed
                        <span className="text-xs ml-2 bg-black rounded px-1 text-white">
                          {dataTicketClose && dataTicketClose.count}
                        </span>
                      </div>
                    </Tab>
                  </TabList>

                  <TabPanel>
                    <div className={`px-0 mb-2`}>
                      <div className={`text-sm flex gap-2 items-center`}>
                        <button
                          onClick={handleRefreshOpen}
                          className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100"
                        >
                          <FaSync /> Refresh
                        </button>

                        <button
                          onClick={HandleToClose}
                          className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border text-black bg-neutral-50 hover:bg-neutral-100"
                        >
                          {loading ? (
                            <PulseLoader color="rgb(239 68 68)" size={11} />
                          ) : (
                            <FaLock className="text-red-500" />
                          )}
                          Close
                        </button>
                      </div>
                    </div>

                    {/* button perpage and input search  */}
                    <div className="flex flex-col md:flex-row md:justify-between align-middle px-0 mb-4  ">
                      <div className="p-1 inline-block align-middle">
                        <select
                          id="limitOpen"
                          value={limitOpen}
                          onChange={(e) =>
                            handleSelectLimitOpen(e.target.value)
                          }
                          className="border rounded-sm p-1 border-gray-300  focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                          <option value={500}>500</option>
                        </select>
                        <span className="mx-2 text-sm ">Records per page</span>
                      </div>
                      <div className="p-1 inline-block align-middle">
                        <span className="text-sm mr-2">Search:</span>
                        <input
                          id="searchOpen"
                          type="text"
                          value={searchOpen}
                          onChange={(e) => onSearchOpen(e.target.value)}
                          placeholder="Search ..."
                          className="p-1 border border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        />
                      </div>
                    </div>
                    {/* table and pagination */}
                    <div className="mx-0 ">
                      <div className="overflow-y-hidden min-h-[55vh]">
                        <table className="w-full">
                          <thead className="text-left">
                            <tr className="">
                              <th className="text-center">
                                <input
                                  id="checkbox-table"
                                  type="checkbox"
                                  className="form-checkbox w-4 h-4"
                                  checked={checkAllOpen}
                                  onChange={handleCheckAllChangeOpen}
                                />
                              </th>
                              {TABLE_HEAD.map((item, itemIdx) => (
                                <th
                                  key={itemIdx}
                                  className="p-2 text-sm whitespace-nowrap cursor-pointer "
                                  onClick={() => {
                                    item.field && handleSortOpen(item.field);
                                  }}
                                >
                                  <div className="flex justify-left">
                                    {item.title}
                                    {item.field &&
                                      renderSortIconOpen(item.field)}
                                  </div>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="text-left">
                            {/* loading  */}
                            {loadingOpen && (
                              <tr>
                                <td
                                  className="text-center py-12"
                                  colSpan={TABLE_HEAD.length + 1}
                                >
                                  <div className="pt-10 pb-6 flex justify-center items-center">
                                    <SyncLoader color="#4477CE" />
                                  </div>
                                </td>
                              </tr>
                            )}
                            {/* Error */}
                            {errorOpen && (
                              <tr>
                                <td
                                  className="text-center"
                                  colSpan={TABLE_HEAD.length + 1}
                                >
                                  <div className="pt-20 pb-12 flex justify-center items-center text-xs text-red-500">
                                    {errorOpen}
                                  </div>
                                </td>
                              </tr>
                            )}
                            {/* Result = 0 */}
                            {dataTicketOpen.results &&
                              dataTicketOpen.results.length === 0 && (
                                <tr>
                                  <td
                                    className="text-center"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-20 pb-12 flex justify-center items-center text-xs text-slate-600 dark:text-white">
                                      No Data
                                    </div>
                                  </td>
                                </tr>
                              )}
                            {dataTicketOpen.results &&
                              dataTicketOpen.results.map((item, index) => (
                                <tr
                                  key={index}
                                  className="h-10 bg-white border-b-[1rem] border-[#f9fafb] "
                                >
                                  <td
                                    className="p-2 text-center border-l-[15px]"
                                    style={{ borderColor: item.priority_color }}
                                  >
                                    <input
                                      id={`checkbox-${item.id}`}
                                      type="checkbox"
                                      className="form-checkbox w-4 h-4"
                                      checked={checkedItemsOpen.includes(
                                        item.id
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChangeOpen(e, item.id)
                                      }
                                    />
                                  </td>
                                  <td className="p-2 relative">
                                    <Link
                                      to={"/tiketsaya/ticketdetail"}
                                      state={{ id: item.id }}
                                      className="text-blue-500 hover:text-blue-600 flex items-center"
                                    >
                                      {`${
                                        item.title &&
                                        slicingWord(item.title, 30)
                                      }`}
                                      <span
                                        title={`has ${item.ticket_thread_count_client} ticket messages `}
                                        className="ml-1 text-green-600"
                                      >
                                        {`(${item.ticket_thread_count_client})`}
                                      </span>
                                      <FaComment className="text-green-600" />
                                    </Link>
                                  </td>
                                  <td className="p-2">
                                    <a href="">{item.ticket_number}</a>
                                  </td>
                                  <td className="p-2 text-green-700 dark:text-green-200">
                                    {item.priority_name}
                                  </td>
                                  <td className="p-2 text-green-500 font-bold text-center">
                                    {item.assignedto_name ?? item.team_name ?? (
                                      <span className="text-lg text-gray-500">
                                        . . .
                                      </span>
                                    )}
                                  </td>
                                  <td className="p-2">
                                    {moment(item.updated_at).format(
                                      "DD/MM/YYYY HH:mm:ss"
                                    )}
                                  </td>
                                  <td className="p-2">
                                    <div className="text-green-500 py-1 border-2 border-green-500 text-center">
                                      {item.status_name}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>

                        <div className="pt-5 py-11">
                          <CompPagination
                            handlePageClick={(e) => handlePageClickOpen(e)}
                            pageCount={
                              dataTicketOpen.count > 0
                                ? dataTicketOpen.count
                                : 0
                            }
                            limit={limitOpen}
                            offset={offsetOpen}
                            currentPage={currentPageOpen}
                          />
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className={`px-0 mb-2`}>
                      <div className={`text-sm flex gap-2 items-center`}>
                        <button
                          onClick={handleRefreshClose}
                          className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100"
                        >
                          <FaSync /> Refresh
                        </button>

                        <button
                          onClick={HandleToOpen}
                          className="flex gap-1 p-1 px-3 items-center rounded shadow-sm border text-black bg-neutral-50 hover:bg-neutral-100"
                        >
                          {loading ? (
                            <PulseLoader color="rgb(34 197 94)" size={11} />
                          ) : (
                            <FaLockOpen className="text-green-500" />
                          )}
                          Open
                        </button>
                      </div>
                    </div>
                    {/* button perpage and input search  */}
                    <div className="flex flex-col md:flex-row md:justify-between align-middle px-0 mb-4 bg-[#f9fafb]  ">
                      <div className="p-1 inline-block align-middle">
                        <select
                          id="limitClose"
                          value={limitClose}
                          onChange={(e) =>
                            handleSelectLimitClose(e.target.value)
                          }
                          className="border rounded-sm p-1 border-gray-300  focus:border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                          <option value={500}>500</option>
                        </select>
                        <span className="mx-2 text-sm ">Records per page</span>
                      </div>
                      <div className="p-1 inline-block align-middle">
                        <span className="text-sm mr-2">Search:</span>
                        <input
                          id="searchClose"
                          type="text"
                          value={searchClose}
                          onChange={(e) => onSearchClose(e.target.value)}
                          placeholder="Search ..."
                          className="p-1 border border-gray-300  focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        />
                      </div>
                    </div>
                    {/* table and pagination */}
                    <div className="mx-0 ">
                      <div className="overflow-y-hidden min-h-[55vh]">
                        <table className="w-full ">
                          <thead className="text-left">
                            <tr className="">
                              <th className="text-center">
                                <input
                                  id="checkbox-table"
                                  type="checkbox"
                                  className="form-checkbox w-4 h-4"
                                  checked={checkAllClose}
                                  onChange={handleCheckAllChangeClose}
                                />
                              </th>
                              {TABLE_HEAD.map((item, itemIdx) => (
                                <th
                                  key={itemIdx}
                                  className="p-2 text-sm whitespace-nowrap cursor-pointer"
                                  onClick={() => {
                                    item.field && handleSortClose(item.field);
                                  }}
                                >
                                  <span className="flex">
                                    {item.title}
                                    {item.field &&
                                      renderSortIconClose(item.field)}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="text-left">
                            {/* loading  */}
                            {loadingClose && (
                              <tr>
                                <td
                                  className="text-center py-12"
                                  colSpan={TABLE_HEAD.length + 1}
                                >
                                  <div className="pt-10 pb-6 flex justify-center items-center">
                                    <SyncLoader color="#4477CE" />
                                  </div>
                                </td>
                              </tr>
                            )}
                            {/* Error */}
                            {errorClose && (
                              <tr>
                                <td
                                  className="text-center"
                                  colSpan={TABLE_HEAD.length + 1}
                                >
                                  <div className="pt-20 pb-12 flex justify-center items-center text-xs text-red-500">
                                    {errorClose}
                                  </div>
                                </td>
                              </tr>
                            )}
                            {/* Result = 0 */}
                            {dataTicketClose.results &&
                              dataTicketClose.results.length === 0 && (
                                <tr>
                                  <td
                                    className="text-center"
                                    colSpan={TABLE_HEAD.length + 1}
                                  >
                                    <div className="pt-20 pb-12 flex justify-center items-center text-xs text-slate-600 dark:text-white">
                                      No Data
                                    </div>
                                  </td>
                                </tr>
                              )}
                            {dataTicketClose.results &&
                              dataTicketClose.results.map((item, index) => (
                                <tr
                                  key={index}
                                  className="h-10 bg-white border-b-[1rem] border-[#f9fafb]"
                                >
                                  <td
                                    className="p-2 text-center border-l-[15px] "
                                    style={{ borderColor: item.priority_color }}
                                  >
                                    <input
                                      id={`checkbox-${item.id}`}
                                      type="checkbox"
                                      className="form-checkbox w-4 h-4"
                                      checked={checkedItemsClose.includes(
                                        item.id
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChangeClose(e, item.id)
                                      }
                                    />
                                  </td>
                                  <td className="p-2 relative">
                                    <Link
                                      to={"/tiketsaya/ticketdetail"}
                                      state={{ id: item.id }}
                                      className="text-blue-500 hover:text-blue-600 flex items-center"
                                    >
                                      {`${
                                        item.title &&
                                        slicingWord(item.title, 30)
                                      }`}
                                      <span
                                        title={`has ${item.ticket_thread_count_client} ticket messages `}
                                        className="ml-1 text-green-600"
                                      >
                                        {`(${item.ticket_thread_count_client})`}
                                      </span>
                                      <FaComment className="text-green-600" />
                                    </Link>
                                  </td>
                                  <td className="p-2">
                                    <a href="">{item.ticket_number}</a>
                                  </td>
                                  <td className="p-2 text-green-700 dark:text-green-200">
                                    {item.priority_name}
                                  </td>
                                  <td className="p-2 text-green-500 font-bold text-center">
                                    {item.assignedto_name ?? item.team_name ?? (
                                      <span className="text-lg text-gray-500">
                                        . . .
                                      </span>
                                    )}
                                  </td>
                                  <td className="p-2">
                                    {moment(item.updated_at).format(
                                      "DD/MM/YYYY HH:mm:ss"
                                    )}
                                  </td>
                                  <td className="p-2">
                                    <div className="text-red-500 py-1 border-2 border-red-500 text-center">
                                      {item.status_name}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>

                        <div className="pt-5 py-11">
                          <CompPagination
                            handlePageClick={(e) => handlePageClickClose(e)}
                            pageCount={
                              dataTicketClose.count > 0
                                ? dataTicketClose.count
                                : 0
                            }
                            limit={limitClose}
                            offset={offsetClose}
                            currentPage={currentPageClose}
                          />
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </main>

        <FooterPortal />
      </div>
    </>
  );
};

export default MyTicket;
